import { InviteToRqModalStep } from '@/components/modals/InviteToRqModal/types'

export const INVITE_TO_RQ_MODAL_STEP: Record<
  InviteToRqModalStep,
  InviteToRqModalStep
> = {
  inviteTypeChoice: 'inviteTypeChoice',
  referralPartners: 'referralPartners',
}
